<template>
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="860px"
               append-to-body @close="handleClose" @closed="handleClosed">
        <el-form ref="formRef" :model="form" :rules="rules" label-width="100px"
                 class="add_user_form" v-loading="loadingConstruction">
            <el-form-item label="姓名" prop="nickname">
                <el-input v-model.trim="form.nickname" maxlength="20" placeholder="请输入姓名"></el-input>
            </el-form-item>
            <el-form-item label="手机号" prop="phone">
                <el-input v-model.trim="form.phone" maxlength="11" placeholder="请输入手机号"></el-input>
            </el-form-item>
            <el-form-item label="建设单位" prop="construction_id">
                <el-select ref="constructionSelect" v-model="form.construction_id" clearable filterable allow-create
                           default-first-option reserve-keyword placeholder="不选默认全部"
                           @change="handleConstructionChange"
                           class="full_width">
                    <el-option v-for="item in constructionList" :key="item.id"
                               :label="item.construction_unit" :value="item.id"></el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog_footer">
            <el-button size="small" class="button_88px" :disabled="saving" @click="dialogVisible=false">
                取消
            </el-button>
            <el-button v-if="!isEdit" size="small" class="button_120px" plain type="primary"
                       :loading="saving" @click="submit(true)">
                保存并设置权限
            </el-button>
            <el-button size="small" class="button_88px" type="primary"
                       :loading="saving" @click="submit(false)">
                保存
            </el-button>
        </div>
    </el-dialog>
</template>

<script>
import api from '@/api/methods/index';
import myPublic from '@/utils/public';

const initForm = () => ({
    userid: '',
    nickname: '',
    phone: '',
    construction_id: ''
});

export default {
    props: {
        show: {
            type: Boolean,
            default: false
        },
        mode: {
            type: String,
            default: 'add'
        },
        userInfo: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        const validatePhone = (rule, value, callback) => {
            if (!value) {
                callback(new Error('请输入手机号'));
                return;
            }
            if (!myPublic.validateMobileNumber(value)) {
                callback(new Error('手机号格式不正确'));
                return;
            }
            callback();
        };
        return {
            dialogVisible: false,
            saving: false,
            loadingConstruction: false,
            syncingConstruction: false,
            closePayload: null,
            currentConstruction: {},
            constructionList: [],
            lastConstructionValue: '',
            form: initForm(),
            rules: {
                nickname: [
                    {required: true, message: '请输入姓名', trigger: 'blur'}
                ],
                phone: [
                    {required: true, message: '请输入手机号', trigger: 'blur'},
                    {validator: validatePhone, trigger: 'blur'}
                ]
            }
        };
    },
    computed: {
        isEdit() {
            return this.mode === 'edit';
        },
        dialogTitle() {
            return this.isEdit ? '编辑人员' : '添加人员';
        }
    },
    watch: {
        show: {
            immediate: true,
            handler(value) {
                this.dialogVisible = value;
                if (value) {
                    this.initDialog();
                }
            }
        }
    },
    methods: {
        async initDialog() {
            this.closePayload = null;
            this.resetForm();
            await this.getConstructionList(true);
        },
        async getConstructionList(fillForm = false) {
            this.loadingConstruction = true;
            let res = await api.contract.GetConstruction({});
            let list = [];
            if (res?.data?.data?.construction) {
                list = res.data.data.construction || [];
            }
            this.constructionList = list;
            if (fillForm) {
                this.fillForm();
            }
            this.loadingConstruction = false;
        },
        setConstructionValue(value) {
            this.syncingConstruction = true;
            this.form.construction_id = value;
            this.$nextTick(() => {
                this.syncingConstruction = false;
            });
        },
        clearConstructionSelection() {
            this.setConstructionValue(this.lastConstructionValue || '');
        },
        //获取当前输入建设的id
        getConstructionItemById(value) {
            return this.constructionList.find(item => {
                return item.id === value || `${item.id}` === `${value}`;
            }) || null;
        },
        //获取当前输入建设单位的name
        getConstructionItemByName(name) {
            if (name === undefined || name === null || name === '') {
                return null;
            }
            let targetName = String(name).trim();
            if (!targetName) {
                return null;
            }
            return this.constructionList.find(item => {
                return String(item.construction_unit || '').trim() === targetName;
            }) || null;
        },
        async createConstruction(value) {
            let constructionName = String(value).trim();
            if (!constructionName) {
                throw new Error('建设单位名称不能为空');
            }
            let saveRes = await api.contract.SaveConstruction({
                construction_unit: constructionName,
                status: 1
            });
            if (saveRes?.data?.state != 1) {
                throw new Error(saveRes?.data?.msg || '建设单位保存失败');
            }
            await this.getConstructionList();
            let savedItem = this.getConstructionItemByName(constructionName);
            if (!savedItem) {
                throw new Error('建设单位创建后未查询到，请重试');
            }
            return savedItem.id;
        },
        confirmCreateConstruction() {
            const h = this.$createElement;
            return new Promise((resolve, reject) => {
                this.$msgbox({
                    title: '提示',
                    message: h('p', null, '建设单位不存在，是否立即创建？'),
                    showCancelButton: true,
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    beforeClose: (action, instance, done) => {
                        done();
                        if (action === 'confirm') {
                            resolve();
                        } else {
                            reject(action);
                        }
                    }
                }).catch(error => {
                    reject(error);
                });
            });
        },
        async handleConstructionChange(value) {
            if (this.syncingConstruction) {
                return;
            }
            if (value === undefined || value === null || value === '') {
                this.lastConstructionValue = '';
                return;
            }
            let currentById = this.getConstructionItemById(value);
            if (currentById) {
                this.lastConstructionValue = currentById.id;
                return;
            }
            let currentByName = this.getConstructionItemByName(value);
            if (currentByName) {
                this.lastConstructionValue = currentByName.id;
                this.setConstructionValue(currentByName.id);
                return;
            }
            let constructionName = String(value).trim();
            if (!constructionName) {
                this.clearConstructionSelection();
                return;
            }
            try {
                await this.confirmCreateConstruction();
            } catch (error) {
                this.clearConstructionSelection();
                return;
            }
            this.syncingConstruction = true;
            try {
                let constructionId = await this.createConstruction(constructionName);
                this.lastConstructionValue = constructionId;
                this.form.construction_id = constructionId;
                this.$nextTick(() => {
                    this.$refs.constructionSelect?.blur();
                });
                this.$message.success('建设单位创建成功');
            } catch (error) {
                this.clearConstructionSelection();
                this.$message.error(error?.message || '建设单位创建失败，请重试');
            } finally {
                this.syncingConstruction = false;
            }
        },
        //处理当前选中的建设单位id
        async ensureConstructionId(value) {
            if (value === undefined || value === null || value === '') {
                return '';
            }
            let currentById = this.getConstructionItemById(value);
            if (currentById) {
                return currentById.id;
            }
            let currentByName = this.getConstructionItemByName(value);
            if (currentByName) {
                return currentByName.id;
            }
            let constructionName = String(value).trim();
            if (!constructionName) {
                return '';
            }
            try {
                await this.confirmCreateConstruction();
            } catch (error) {
                return null;
            }
            let savedId = await this.createConstruction(constructionName);
            this.lastConstructionValue = savedId;
            return savedId;
        },
        fillForm() {
            let form = initForm();
            this.currentConstruction = {};
            if (this.isEdit) {
                form.userid = this.userInfo?.userid || this.userInfo?.user_id || '';
                form.nickname = this.userInfo?.nickname || '';
                form.phone = this.userInfo?.phone || '';
                if (this.userInfo?.construction) {
                    this.currentConstruction = {
                        record_id: this.userInfo.construction.record_id || '',
                        construction_id: this.userInfo.construction.construction_id || ''
                    };
                }
                form.construction_id = this.currentConstruction.construction_id || '';
            }
            this.form = form;
            if (this.$refs.formRef) {
                this.$nextTick(() => {
                    this.$refs.formRef.clearValidate();
                });
            }
            this.lastConstructionValue = form.construction_id || '';
        },
        submit(openSetPower) {
            if (this.saving) {
                return;
            }
            this.$refs.formRef.validate(async (valid) => {
                if (!valid) {
                    return;
                }
                if (this.syncingConstruction) {
                    this.$message({
                        message: '建设单位处理中，请稍后',
                        type: 'warning'
                    });
                    return;
                }
                this.saving = true;
                let constructionId = '';
                try {
                    constructionId = await this.ensureConstructionId(this.form.construction_id);
                } catch (error) {
                    this.saving = false;
                    this.$message({
                        message: error?.message || '建设单位保存失败',
                        type: 'warning'
                    });
                    return;
                }
                if (constructionId === null) {
                    this.saving = false;
                    return;
                }
                this.form.construction_id = constructionId;
                let userid = this.form.userid || '';
                let shouldSaveUser = !this.isEdit
                    || this.form.nickname !== (this.userInfo?.nickname || '')
                    || this.form.phone !== (this.userInfo?.phone || '');
                if (shouldSaveUser) {
                    let param = {
                        nickname: this.form.nickname,
                        phone: this.form.phone
                    };
                    if (this.form.userid) {
                        param.userid = this.form.userid;
                    }
                    let res = await api.authority.addUser(param);
                    if (res?.data?.state != 1) {
                        this.saving = false;
                        return;
                    }
                    userid = userid || res.data.userid || '';
                    if (!userid) {
                        this.saving = false;
                        this.$message({
                            message: '人员已保存成功，保存建设单位失败，请重新编辑该人员处理',
                            type: 'warning'
                        });
                        return;
                    }
                    this.form.userid = userid;
                }
                let saveConstructionSuccess = await this.saveConstructionUser(userid);
                this.saving = false;
                if (!saveConstructionSuccess) {
                    return;
                }
                let selectedConstruction = this.constructionList.find(item => `${item.id}` === `${this.form.construction_id}`);
                let user = {
                    userid,
                    nickname: this.form.nickname,
                    phone: this.form.phone,
                    construction: this.form.construction_id ? {
                        construction_id: this.form.construction_id,
                        construction_unit: selectedConstruction?.construction_unit || ''
                    } : null
                };
                this.$message({
                    message: '保存成功',
                    type: 'success'
                });
                this.lastConstructionValue = this.form.construction_id || '';
                if (this.isEdit) {
                    openSetPower = false;
                }
                this.closePayload = {user, openSetPower};
                this.dialogVisible = false;
            });
        },
        //保存建设单位
        async saveConstructionUser(userid) {
            let oldConstructionId = this.currentConstruction?.construction_id ? `${this.currentConstruction.construction_id}` : '';
            let newConstructionId = this.form.construction_id ? `${this.form.construction_id}` : '';
            if (oldConstructionId === newConstructionId) {
                return true;
            }
            if (this.currentConstruction?.record_id) {
                let deleteRes = await api.contract.SaveConstructionUser({
                    id: this.currentConstruction.record_id,
                    construction_id: this.currentConstruction.construction_id,
                    userid,
                    status: 2
                });
                if (deleteRes?.data?.state != 1) {
                    this.$message({
                        message: deleteRes?.data?.msg || '建设单位保存失败',
                        type: 'warning'
                    });
                    return false;
                }
                this.currentConstruction = {};
            }
            if (!newConstructionId) {
                return true;
            }
            let addRes = await api.contract.SaveConstructionUser({
                construction_id: newConstructionId,
                userid,
                status: 1
            });
            if (addRes?.data?.state != 1) {
                this.$message({
                    message: addRes?.data?.msg || '建设单位保存失败',
                    type: 'warning'
                });
                return false;
            }
            this.currentConstruction = {
                construction_id: this.form.construction_id
            };
            return true;
        },
        resetForm() {
            this.form = initForm();
            this.currentConstruction = {};
            this.syncingConstruction = false;
            this.lastConstructionValue = '';
            if (this.$refs.formRef) {
                this.$nextTick(() => {
                    this.$refs.formRef.clearValidate();
                });
            }
        },
        handleClose() {
            this.$emit('update:show', false);
        },
        handleClosed() {
            this.saving = false;
            this.loadingConstruction = false;
            this.resetForm();
            if (this.closePayload) {
                this.$emit('saved', this.closePayload);
                this.closePayload = null;
            }
        }
    }
};
</script>

<style scoped lang="less">
.add_user_form {
    padding: 10px 20px 0;

    .full_width {
        width: 100%;
    }
}

.dialog_footer {
    display: flex;
    justify-content: flex-end;
}
</style>
